export const cn_freeVip = {
  twoweek: [
    { label: 'PaymentModal-Freature-Removal' },
    { label: 'merror.sub.vt' },
    { label: 'PaymentModal-Freature-AvatarVideo' },
    { label: 'merror.sub.vfs' },
    { label: 'PaymentModal-Feature-Free-Avatars-Voices' },
    { label: 'PaymentModal-Feature-Custom-Avatars-ValidDay', value: { num: 2, day: 7 } },
    { label: 'PaymentModal-Feature-Voice-Clone-ValidDay', value: { num: 1, day: 7 } },
    { label: 'Video-save-for-7-days', value: { amount: 7 } },
  ],
  month: [
    { label: 'PaymentModal-Freature-Removal' },
    { label: 'merror.sub.vt' },
    { label: 'PaymentModal-Freature-AvatarVideo' },
    { label: 'merror.sub.vfs' },
    { label: 'PaymentModal-Feature-Free-Avatars-Voices' },
    { label: 'PaymentModal-Feature-Custom-Avatars-ValidDay', value: { num: 2, day: 7 } },
    { label: 'PaymentModal-Feature-Voice-Clone-ValidDay', value: { num: 1, day: 7 } },
    { label: 'Video-save-for-7-days', value: { amount: 7 } },
  ],
  year: [
    { label: 'PaymentModal-Freature-Removal' },
    { label: 'merror.sub.vt' },
    { label: 'PaymentModal-Freature-AvatarVideo' },
    { label: 'merror.sub.vfs' },
    { label: 'PaymentModal-Feature-Free-Avatars-Voices' },
    { label: 'PaymentModal-Feature-Custom-Avatars-ValidDay', value: { num: 2, day: 7 } },
    { label: 'PaymentModal-Feature-Voice-Clone-ValidDay', value: { num: 1, day: 7 } },
    { label: 'Video-save-for-7-days', value: { amount: 7 } },
  ],
};
export const cn_basicVip = {
  twoweek: [
    { label: 'merror.sub.at' },
    { label: 'Translation-with-lipsync' },
    { label: 'bc.text.style.edit' },
    { label: 'Watermark-removal' },
    { label: 'PaymentModal-Feature-All-Avatars-Voices' },
    { label: 'PaymentModal-Feature-Custom-Avatars-ValidDay', value: { num: 5, day: 30 } },
    { label: 'PaymentModal-Feature-Voice-Clone-ValidDay', value: { num: 5, day: 30 } },
    { label: 'Video-save-for-7-days', value: { amount: 30 } },
  ],
  month: [
    { label: 'merror.sub.at' },
    { label: 'Translation-with-lipsync' },
    { label: 'bc.text.style.edit' },
    { label: 'Watermark-removal' },
    { label: 'PaymentModal-Feature-All-Avatars-Voices' },
    { label: 'PaymentModal-Feature-Custom-Avatars-ValidDay', value: { num: 5, day: 30 } },
    { label: 'PaymentModal-Feature-Voice-Clone-ValidDay', value: { num: 5, day: 30 } },
    { label: 'Video-save-for-7-days', value: { amount: 30 } },
  ],
  year: [
    { label: 'merror.sub.at' },
    { label: 'Translation-with-lipsync' },
    { label: 'bc.text.style.edit' },
    { label: 'Watermark-removal' },
    { label: 'PaymentModal-Feature-All-Avatars-Voices' },
    { label: 'PaymentModal-Feature-Custom-Avatars-ValidDay', value: { num: 5, day: 30 } },
    { label: 'PaymentModal-Feature-Voice-Clone-ValidDay', value: { num: 5, day: 30 } },
    { label: 'Video-save-for-7-days', value: { amount: 30 } },
  ],
};
export const cn_advancedVip = {
  twoweek: [
    { label: 'Batch-process-videos' },
    { label: 'PaymentModal-Feature-Buy-More-Credit' },
    { label: 'PaymentModal-Feature-All-Avatars-Voices' },
    {
      label: 'PaymentModal-Feature-Custom-Avatars',
      value: { num: 30 },
    },
    { label: 'PaymentModal-Feature-Voice-Clone', value: { num: 30 } },
    { label: 'Video-save-for-7-days', value: { amount: 60 } },
    { label: 'PaymentModal-Feature-First-Priority-Rendering-Speed' },
  ],
  month: [
    { label: 'Batch-process-videos' },
    { label: 'PaymentModal-Feature-Buy-More-Credit' },
    { label: 'PaymentModal-Feature-All-Avatars-Voices' },
    {
      label: 'PaymentModal-Feature-Custom-Avatars',
      value: { num: 30 },
    },
    { label: 'PaymentModal-Feature-Voice-Clone', value: { num: 30 } },
    { label: 'Video-save-for-7-days', value: { amount: 60 } },
    { label: 'PaymentModal-Feature-First-Priority-Rendering-Speed' },
  ],
  year: [
    { label: 'Batch-process-videos' },
    { label: 'PaymentModal-Feature-Buy-More-Credit' },
    { label: 'PaymentModal-Feature-All-Avatars-Voices' },
    {
      label: 'PaymentModal-Feature-Custom-Avatars',
      value: { num: 30 },
    },
    { label: 'PaymentModal-Feature-Voice-Clone', value: { num: 30 } },
    { label: 'Video-save-for-7-days', value: { amount: 60 } },
    { label: 'PaymentModal-Feature-First-Priority-Rendering-Speed' },
  ],
};
export const cn_enterpriseVip = {
  twoweek: [
    { label: 'Everything-in-Pro' },
    { label: 'merror.sub.avatars' },
    { label: 'merror.sub.voices' },
    { label: 'merror.sub.length' },
    { label: 'New-user-text3' },
    { label: 'merror.sub.more' },
  ],
  month: [
    { label: 'Everything-in-Pro' },
    { label: 'merror.sub.avatars' },
    { label: 'merror.sub.voices' },
    { label: 'merror.sub.length' },
    { label: 'New-user-text3' },
    { label: 'merror.sub.more' },
  ],
  year: [
    { label: 'Everything-in-Pro' },
    { label: 'merror.sub.avatars' },
    { label: 'merror.sub.voices' },
    { label: 'merror.sub.length' },
    { label: 'New-user-text3' },
    { label: 'merror.sub.more' },
  ],
};

export const us_freeVip = {
  twoweek: [
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-2' },
    { label: 'merror.translation.title' },
    { label: 'fd50be63aeda598507621dc9e8027c72' },
    { label: 'a13dbe473b6c594603f2ea285a115ddc' },
    { label: 'AI-4' },
    { label: 'b8abbcd708f2e3fa20e39734ebfc4336' },
  ],
  month: [
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-1' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-2' },
    { label: 'b8abbcd708f2e3fa20e39734ebfc4336' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-10', value: { num: 1 } },
  ],
  year: [
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-1' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-2' },
    { label: 'b8abbcd708f2e3fa20e39734ebfc4336' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-10', value: { num: 1 } },
  ],
};
export const us_basicVip = {
  twoweek: [
    { label: 'AI-5' },
    { label: 'Product-avatar-video' },
    { label: 'num', value: { num: 30 } },
    { label: 'num-2', value: { num: 30 } },
    { label: 'Watermark-removal' },
  ],
  month: [
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-11' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-12' },
    { label: 'Watermark-removal' },
    { label: 'Batch-process-videos' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-10', value: { num: 5 } },
  ],
  year: [
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-11' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-12' },
    { label: 'Watermark-removal' },
    { label: 'Batch-process-videos' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-10', value: { num: 5 } },
  ],
};
export const us_advancedVip = {
  twoweek: [
    { label: 'AI-6' },
    { label: '68996912f4f1164c52173416c8203685' },
    { label: 'ad09306fe778cc9ed36993178c837636' },
    { label: 'Batch-process-videos' },
    { label: 'f88a381f03b39fba426386857f6b065f' },
  ],
  month: [
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-11' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-13' },
    { label: 'Watermark-removal' },
    { label: 'Batch-process-videos' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-14' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-10', value: { num: 30 } },
  ],
  year: [
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-11' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-13' },
    { label: 'Watermark-removal' },
    { label: 'Batch-process-videos' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-14' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-10', value: { num: 30 } },
  ],
};

export const us_enterpriseVip = {
  twoweek: [
    { label: 'Everything-in-Pro' },
    { label: 'merror.sub.avatars' },
    { label: 'merror.sub.voices' },
    { label: 'merror.sub.length' },
    { label: 'New-user-text3' },
    { label: 'merror.sub.more' },
  ],
  month: [
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-15' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-16' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-17' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-18' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-19' },
  ],
  year: [
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-15' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-16' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-17' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-18' },
    { label: '9a1641a16a4cc4df9ffa2a17b6348ae0-19' },
  ],
};

export const featureIntl = {
  cn: {
    freeVip: cn_freeVip,
    basicVip: cn_basicVip,
    advancedVip: cn_advancedVip,
    enterpriseVip: cn_enterpriseVip,
  },
  us: {
    freeVip: us_freeVip,
    basicVip: us_basicVip,
    advancedVip: us_advancedVip,
    enterpriseVip: us_enterpriseVip,
  },
};
